import React from "react";
import SkillItem from "./SkillItem";

const skillData = [
  {
    id: 1,
    title: "sobre.skills.arquitetura",
    percentage: "100%",
  },
  {
    id: 2,
    title: "sobre.skills.java",
    percentage: "95%",
  },
  {
    id: 3,
    title: "sobre.skills.cloud",
    percentage: "90%",
  },
  {
    id: 4,
    title: "sobre.skills.gestao",
    percentage: "85%",
  },
  {
    id: 5,
    title: "sobre.skills.api",
    percentage: "90%",
  },
  {
    id: 6,
    title: "sobre.skills.javascript",
    percentage: "85%",
  },
  {
    id: 7,
    title: "sobre.skills.quarkus",
    percentage: "60%",
  },
];

const Skills = () => {
  return (
    <div className="py-4">
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">Skills</h3>
          </div>
        </div>
        {skillData.map((skill, id) => (
          <SkillItem skill={skill} key={id} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
